<main [@fadeInOut] role="main" id="main-heading" tabindex="0">
<div class="wrapper padding-bottom">
    <div class="container-fluid" id="wrapper">
        <!-- <form [formGroup]="frmBusinessCategory" novalidate #newUserForm="ngForm" (keydown.enter)="$event.preventDefault()"> -->
        <div class="col-sm-11 center-block">
            <div class="col-sm-12">
                <div class="col-sm-12">
                    <h1 tabindex="0" aria-label="Settings" role="heading" aria-level="1">Settings</h1>
                    <p id="demo"></p>
                </div>
            </div>

            <div class="col-sm-12">
                <div class="col-sm-12 top-space">
                    <h4 tabindex="0" aria-label="Current Business Categories" role="heading" aria-level="4">Current Business Categories</h4>
                </div>
                <div class="col-sm-4 top-space">
                    <div>
                        <button class="btn btn-primary" (click)="openEditModal('')"
                            [disabled]="!bHasPermission" tabindex="0" role="button" aria-label="add business category" (keydown.enter)="openEditModal('')">
                            Add Business Category
                        </button>
                    </div>
                </div>
            </div>
            <div class="row top-space">
                <div class="col-sm-12 ps-0">
                    <div class="col-sm-9">
                      <ejs-tooltip #tooltip id="tooltip" (beforeRender)="tooltipValue($event)"
                                target=".e-tooltipcolumn" [enableHtmlParse]="false">
                        <ejs-grid id='business_Category_Grid' #businessCategory_grid
                            [dataSource]='businessCategory_grid_data' allowPaging='true' allowSorting='true'
                            [pageSettings]='initialPage' height="470" (queryCellInfo)=customizeCell($event)
                            (actionBegin)=begin($event) [toolbar]='toolbarOptions' allowScrolling="true"
                            allowFiltering="true">
                            <e-columns>
                               <e-column [customAttributes]="clipmodecolumn" field='label' headerText='Name' clipMode="EllipsisWithTooltip" width='200'>
                                    <ng-template #template let-businessCategory_grid_data>
                                        <a class='pointer'
                                            (click)='openEditModal(businessCategory_grid_data.categoryId)'
                                            tabindex="0" role="link" aria-label="open modal" (keydown.enter)="openEditModal(businessCategory_grid_data.categoryId)">{{businessCategory_grid_data.label}}</a>
                                    </ng-template>
                                </e-column>
                               <e-column [customAttributes]="clipmodecolumn" field='description' headerText='Description' clipMode="EllipsisWithTooltip"
                                    width='400'>
                                </e-column>
                               <e-column [customAttributes]="clipmodecolumn" field='activeFlag' headerText='Status' clipMode="EllipsisWithTooltip"
                                    width='100'>
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                        </ejs-tooltip>
                    </div>
                    <div class="col-sm-3"></div>
                </div>
                <div *ngIf="loading">
                    <div id="loading"></div>
                </div>
            </div>
        </div>
        <!-- </form> -->
    </div>
</div>

<!-- Create/Modify Business Category-->
<ejs-dialog #EditBCModalDialog [isModal]='isModal' [visible]='EditBCModalDialogVisible' [position]='position'
    [animationSettings]='animationSettings' [width]='modalWidth'>
    <ng-template #content>
        <form [formGroup]="frmEditBusinessCategory" novalidate #mergeForm="ngForm" role="form" aria-label="edit business category form" tabindex="0">
            <div class="card">
                <div class="card-header bg-primary">
                    <h3 class="card-title text-white" tabindex="0" aria-label="Business Category" role="heading" aria-level="3">Business Category</h3>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="form-group col-md-10">
                            <label for="name" id="name-label">Name</label>
                            <input type="text" formControlName="name" class="form-control required" maxlength="20"
                            aria-labelledby="name-label" role="textbox" aria-required="true" aria-label="Enter name"/>
                            <div *ngIf="submitted && f.name.errors" class="alert-text">
                                <div *ngIf="f.name.errors.required" aria-label="name is required">Name is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-10">
                            <label for="description" id="description-label">Description</label>
                            <input type="text" formControlName="description" class="form-control"
                                maxlength="200" aria-labelledby="description-label" role="textbox" aria-label="Enter description"/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 small-padding-top">
                            <br />
                            <div class="form-check form-check-inline" tabindex="0">
                                <label class="form-check-label" id="active-label"></label>
                                <input type="radio" formControlName="status" value="Active" class="form-check-input required"
                                aria-labelledby="active-label" role="radio" aria-label="business category active" tabindex="0"/>Active
                            </div>
                            <div class="form-check form-check-inline" tabindex="0">
                              <label class="form-check-label" id="inactive-label"> </label>
                              <input type="radio" formControlName="status" value="Inactive" class="form-check-input required"
                              aria-labelledby="inactive-label" role="radio" aria-label="business category inactive" tabindex="0"/>Inactive
                            </div>
                        </div>
                    </div>
                    <div class='row'>
                        <div class="col-md-12 top-space">
                            <span>
                                <a class="btn btn-default right-margin" (click)="cancelBtnClicked()" tabindex="0"
                                role="link" aria-label="cancel button" (keydown.enter)="cancelBtnClicked()">Cancel</a>
                            </span>
                            <span>
                                <button class="btn btn-primary margin-right" (click)="saveBusinessCategory()"
                                    [disabled]="!bHasPermission" tabindex="0" role="button" aria-label="save button" (keydown.enter)="saveBusinessCategory()">Save</button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </ng-template>
</ejs-dialog>
</main>
